module.exports = __webpack_public_path__ + "static/media/Hotel-2@2x.e9b5299e.png";